import { mapState, mapActions } from '@/store/helpers';
import { UPDATE_URL } from '../_store/types';
let updateUrlCount = 0;
export default function(injectConditionChange = true) {
    let cfg = {
        computed: {
            ...mapState({
                "fetchedSearchData": store => store.fetchedSearchData,
                "searchParamsWithMap": "searchParamsWithMap"
            }),
        },
        beforeMount() {
            this.watchFetchedSearchData();
        },
        methods: {
            ...mapActions({
                "updateUrl": UPDATE_URL
            }),
            dispatchConditions(conditions) {
                if (conditions.kee === undefined) {
                    return; 
                }
                conditions = {
                    ...conditions,
                    condition: { ...this.searchParamsWithMap }
                };
                this.blockOb?.dispatch('conditionChange', conditions);
                this.conditionChange(conditions);
                if (this.blockName === 'md-snapshot-search' && updateUrlCount > 0) {
                    this.updateUrl();
                }
                updateUrlCount++;
            },
            //  Search criteria ready ， active trigger searchSeoInitData， trigger a destroy 
            watchFetchedSearchData() {
                let unwatch = this.$watch(
                    'fetchedSearchData',
                    newVal => {
                        if (newVal) {
                            this.blockOb?.dispatch('searchSeoInitData', {
                                condition: { ...this.searchParamsWithMap }
                            });
                            unwatch && unwatch(); //  cancel observation 
                        }
                    },
                    { immediate: true }
                );
            }
        }
    }
    if (injectConditionChange) {
        cfg.inject = {
            conditionChange: {
                default() {
                    return function() { };
                }
            }
        }
    }
    return cfg;
}
